import { jsPDF } from "jspdf";
import { imgVertical, helpQR, jackKgImage, certificateCE, certificateNSF, certificateSAA, certifcateIC, certificateSGS, gregWeightKg } from "../dataImg";
import PerfectMooseDecoder from "../../../../decoder";
import JsBarcode from "jsbarcode";

/*
  TO DO :
  - misc certificates
  - misc lower images
*/

const pm = new PerfectMooseDecoder();

async function printFinishedProductLabel(product) {
  const canvas = document.createElement('canvas');
  JsBarcode(canvas, product.reference, { format: "code39" });

  // Get the barcode as a data URL to use in the PDF
  const barcodeDataUrl = canvas.toDataURL('image/png');

  const decoded = pm.decodeToJson(product.reference);
  console.log("Decoded: ", decoded);

  const machineWeight = (product.reference?.includes("PMG")) ? "12.7 kg (28 lb)" : "20.4 kg (45 lb)"
  const packaging = (product.reference?.includes("PMG")) ? "47x70x19 cm  (18.5x27.5x7.5 in)" : "61x70x19 cm  (24x27.5x7.5 in)"
  const doc = new jsPDF("l", "mm", [104, 159]);
  const weightImage = (product.reference?.includes("PMG")) ? gregWeightKg : jackKgImage

  doc.addImage(imgVertical, "png", 5, 3, 21, 30, '', 'FAST');

  doc.setFontSize(11);
  doc.setFont("helvetica", "normal");

  // no bold
  printLine(doc, "S/N", product.serialnumber, 8);
  printLine(doc, "Model", product.reference, 13);
  printLine(doc, "Model name", decoded.pitcher_holder + " " + decoded.machine_type, 18);
  printLine(doc, "Colour", product.color, 23);
  printLine(doc, "Power", decoded.power, 28);
  printLine(doc, "Plug type", decoded.cable_type, 33);
  printLine(doc, "Input", decoded.voltage + "  " + decoded.frequency + "  1~", 38);
  printLine(doc, "Software", product.software, 43);
  printLine(doc, "Recipe", product.recipe, 48);
  printLine(doc, "Gross weight", machineWeight, 53);
  printLine(doc, "Packaging", packaging, 58);

  renderCertificates(doc, product.reference, decoded.cable_type);

  // add the barcode to the left of the certficates turn it 90 degrees
  doc.addImage(barcodeDataUrl, "png", 158, 45, 60, 0, '', 'FAST', 90);

  // on the left the kg image
  doc.addImage(weightImage, "png", 7, 79, 18, 18, '', 'FAST');

  doc.addImage(helpQR, "png", 134, 77, 20, 20, '', 'FAST');
  doc.setFontSize(8);
  doc.text("help.perfectmoose.com", 125, 100);

  doc.addImage(product.barcode, "JPEG", 50, 82, 60, 20, '', 'FAST');

  doc.save(`serial_${product.serialnumber}.pdf`);
}

function printLine(doc, content1, content2, y) {
  doc.text(content1, 37, y);
  doc.text(content2, 67, y);
}

function renderCertificates(doc, reference, cablePart) {
  var yStart = 6;


  if (reference.includes("PMG10")) {
    doc.addImage(certificateNSF, "png", 125, yStart, 8, 0, '', 'FAST');
    doc.addImage(certificateSGS, "png", 122, yStart + 10, 15, 0, '', 'FAST');
    return;
  }

  if (reference.includes("PMG20")) {
    doc.addImage(certificateCE, "png", 125, yStart, 8, 0, '', 'FAST');
    return;
  }

  if (reference.includes("PMJ30") || reference.includes("PMJ31")) {
    doc.addImage(certificateNSF, "png", 125, yStart, 8, 0, '', 'FAST');
    doc.addImage(certificateSGS, "png", 122, yStart + 10, 15, 0, '', 'FAST');
    return;
  }

  if (reference.includes("PMJ20") || reference.includes("PMJ21")) {
    if(cablePart?.includes("Y") || (cablePart?.includes("FB")|| cablePart?.includes("FZ"))) {
      doc.addImage(certificateCE, "png", 125, yStart, 8, 0, '', 'FAST');
      doc.addImage(certificateNSF, "png", 125, yStart + 10, 8, 0, '', 'FAST');
      doc.addImage(certificateSGS, "png", 122, yStart + 20, 15, 0, '', 'FAST');
    } else {
      doc.addImage(certificateCE, "png", 125, yStart, 8, 0, '', 'FAST');
      doc.addImage(certificateNSF, "png", 125, yStart + 10, 8, 0, '', 'FAST');
    }
  }
}

export { printFinishedProductLabel };